import React, { useEffect, useState } from "react";
import { useData } from "../../context/DataContext";
import { MultiImageUploadField } from "../../utils/ImageUploadField";
import { confirmDelete, successToast, errorToast } from "../../utils/dialog";

export default function AdminContactHero() {
  const { contactHeroData, updateContactHeroData, deleteContactHeroImage } =
    useData();
  const [formData, setFormData] = useState({
    title: "",
    highlightText: "",
  });
  const [bgFiles, setBgFiles] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setFormData({
      title: contactHeroData.title || "",
      highlightText: contactHeroData.highlightText || "",
    });
    setBgFiles([]);
  }, [contactHeroData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await updateContactHeroData(formData, bgFiles);
      successToast("Contact Hero updated.");
    } catch (error) {
      console.error("Error updating contact hero:", error);
      errorToast("An error occurred. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="p-6 space-y-6">
      <h2 className="text-2xl font-bold text-gray-800">Update Contact Hero</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Title
          </label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
            className="w-full border border-gray-300 rounded px-3 py-2 text-sm"
            placeholder="Hero title"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Highlight Text
          </label>
          <input
            type="text"
            name="highlightText"
            value={formData.highlightText}
            onChange={handleInputChange}
            className="w-full border border-gray-300 rounded px-3 py-2 text-sm"
            placeholder="Highlighted text"
          />
        </div>

        <MultiImageUploadField
          label="Background Images"
          hint="Recommended size: 1920×1080px (16:9)"
          aspect="wide"
          existingUrls={contactHeroData.backgroundUrls || []}
          newFiles={bgFiles}
          onAdd={(picked) => setBgFiles((prev) => [...prev, ...picked])}
          onRemove={async (idx, isExisting) => {
            if (isExisting) {
              if (
                await confirmDelete({
                  title: "Remove image?",
                  text: "This image will be removed from the carousel.",
                  confirmText: "Yes, remove it",
                })
              ) {
                await deleteContactHeroImage(idx);
              }
            } else {
              setBgFiles((prev) => prev.filter((_, i) => i !== idx));
            }
          }}
        />

        <div>
          <button
            type="submit"
            className={`bg-[#14251F] hover:bg-[#1f3a30] text-[#FFD1A0] px-6 py-2 rounded-lg transition font-medium ${
              saving ? "opacity-60 cursor-not-allowed" : ""
            }`}
            disabled={saving}
          >
            {saving ? "Updating..." : "Update Contact Hero"}
          </button>
        </div>
      </form>
    </div>
  );
}
